import { Component, OnInit, NgZone, Output, EventEmitter, ViewChild, OnDestroy } from '@angular/core';
import { EbiService } from '../../shared/ebi.service';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { HttpClient } from '@angular/common/http';
import { AngularFireStorage } from '@angular/fire/storage';
import { AuthenticationService } from '../../shared/authentication.service';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import { AmChartsLogo } from '@amcharts/amcharts4/.internal/core/elements/AmChartsLogo';
import { anyToNumber } from '@amcharts/amcharts4/.internal/core/utils/Utils';
import { any } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { Item } from '../test-list/test-list.component';
import { AngularFireAuth } from '@angular/fire/auth';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
// @ts-ignore
import {} from '@types/googlemaps';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ApiService } from '../../shared/api.service';

@Component({
  selector: 'app-test-detail',
  templateUrl: './test-detail.component.html',
  styleUrls: ['./test-detail.component.css']
})
export class TestDetailComponent implements OnInit, OnDestroy {

  constructor(private ebi: EbiService, private zone: NgZone, private http: HttpClient, private fireStorage: AngularFireStorage,
              private firestore: AngularFirestore, private httpClient: HttpClient, private authenticationService: AuthenticationService,
              private route: ActivatedRoute, private angularFireAuth: AngularFireAuth, private router: Router,
              private apiService: ApiService) {
  }

  uid: string;
  private chart: am4charts.XYChart;
  isAdmin: boolean;
  isOrgAdmin: boolean;
  isLabUser: boolean;
  loading = true;


  private itemsCollection: AngularFirestoreCollection<Item>;
  items: Observable<Item[]>;
  selectedItem: Item;
  show = 10;
  testid: string;
  userdata: any;
  @ViewChild('placesRef') placesRef: GooglePlaceDirective;
  @ViewChild('waterSourceTrigger') autocomplete: MatAutocompleteTrigger;

  @Output() public testDetailClose: EventEmitter<boolean> = new EventEmitter();
  selectingWaterSource = false;
  // predictionText: string;
  // autocompleteService = new google.maps.places.AutocompleteService();
  // placesService = new google.maps.places.PlacesService(document.createElement('div'));
  // predictionsArray: any[] = [];
  testLoaded = false;
  userSavedPlaces: any[];
  userSavedWaterSources: any[];
  filteredUserSavedPlaces: any[];
  filteredUserSavedWaterSources: any[];
  lastTypedValue: string;
  lastTypedSourceValue: string;
  apiUid: string;
  isDuplicatePlace = false;
  // showLocationClear = false;
  // showWaterSourceClear = false;
  idToken: string;
  filters = {
    test_id: '', orgUsers: undefined
  };
  private itemSubscription: Subscription;
  userOrgId: string;
  isEditingLocation = false;
  isEditingWaterSource = false;
  isEditingNote = false;
  userOrgData;
  routeData;
  loaded;
  position;
  userRole: string;
  testUserData;
  private orgUsers: Array<any> = [];

  markerOptions = {
    animation: google.maps.Animation.DROP,
    icon: './assets/icon.png'
  };

  ngOnInit(): void {
    // scroll to top
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    this.angularFireAuth.authState.subscribe(async user => {
      if (user && user.uid) {
        console.log(user);
        this.userdata = this.authenticationService.userData;
        this.userRole = this.authenticationService.userRole;
        this.isAdmin = this.authenticationService.isAdmin;
        this.isOrgAdmin = this.authenticationService.isOrgAdmin;
        this.isLabUser = this.authenticationService.isLabUser;
        const token = await user.getIdTokenResult();
        this.idToken = token.token;
        this.userOrgId = token.claims?.orgData?.orgId;
        this.uid = this.userdata.uid;
        this.testid = this.route.snapshot.paramMap.get('id');
        this.filters.test_id = this.testid;
        console.log('this.userdata', this.userdata);
        try {
          if (this.userRole === 'admin') {
            await this.loadOrgUsers();
          }
          await this.loadTests();
        } catch (e) {
          console.log(e);
          await this.router.navigate(['/tests']);
        }
      } else {
        await this.router.navigate(['/']);
      }
    });
  }


  async loadTests() {
    this.loaded = false;
    // tslint:disable-next-line:one-variable-per-declaration
    let ref, s1, s2, s3;
    if (this.userRole === 'admin') {
      this.filters.orgUsers = this.orgUsers[0] ? this.orgUsers : undefined;

    }
    // one time test data fetch
    const testItem = await this.apiService.getTestData({filters: this.filters}, this.idToken);
    const testItemData = testItem?.data[0];
    this.selectedItem = testItemData;
    this.position = {lat: this.selectedItem.location?.lat, lng: this.selectedItem.location?.lng};
    if (!this.selectedItem) {
      await this.router.navigate(['/tests']);
      return;
    }
    this.apiUid = this.userRole === 'superuser' ? this.selectedItem.uid : this.uid;
    await this.getUserSavedData(this.idToken, true);


    this.testLoaded = true;

    // this.predictionText = this.selectedItem.location.formatted_address;

    console.log('testtype is ' + this.selectedItem.calculationResult.testType);

    if (this.selectedItem.calculationResult.testType === 'ecoli') {


      switch (this.selectedItem.calculationResult.eColiStage) {
        case 1: {
          s1 = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '-eColiStage1.txt');
          this.createGraph('stage1Div', s1);
          break;
        }
        case 2: {
          s1 = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '-eColiStage1.txt');
          s2 = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '-eColiStage2.txt');
          this.createGraph('stage1Div', s1);
          this.createGraph('stage2Div', s2);
          break;
        }
        case 3: {
          s1 = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '-eColiStage1.txt');
          s2 = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '-eColiStage2.txt');
          s3 = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '-eColiStage3.txt');
          this.createGraph('stage1Div', s1);
          this.createGraph('stage2Div', s2);
          this.createGraph('stage3Div', s3);
          break;
        }
      }


    } else if (this.selectedItem.calculationResult.testType === 'c19') {

      ref = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '-c19Stage' +
        this.selectedItem.calculationResult.c19Stage + '.txt');

      switch (this.selectedItem.calculationResult.c19Stage) {
        case 1: {
          s1 = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '-c19Stage1.txt');
          this.createGraph('stage1Div', s1);
          break;
        }
        case 2: {
          s1 = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '-c19Stage1.txt');
          s2 = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '-c19Stage2.txt');
          this.createGraph('stage1Div', s1);
          this.createGraph('stage2Div', s2);
          break;
        }
        case 3: {
          s1 = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '-c19Stage1.txt');
          s2 = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '-c19Stage2.txt');
          s3 = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '-c19Stage3.txt');
          this.createGraph('stage1Div', s1);
          this.createGraph('stage2Div', s2);
          this.createGraph('stage3Div', s3);
          break;
        }
      }

    } else if (this.selectedItem.calculationResult.testType === 'legionella') {
      switch (this.selectedItem.calculationResult.legionellaStage) {
        case 1: {
          s1 = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '-legionellaStage1.txt');
          this.createGraph('stage1Div', s1);
          break;
        }
        case 2: {
          s1 = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '-legionellaStage1.txt');
          s2 = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '-legionellaStage2.txt');
          this.createGraph('stage1Div', s1);
          this.createGraph('stage2Div', s2);
          break;
        }
        case 3: {
          s1 = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '-legionellaStage1.txt');
          s2 = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '-legionellaStage2.txt');
          s3 = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '-legionellaStage3.txt');
          this.createGraph('stage1Div', s1);
          this.createGraph('stage2Div', s2);
          this.createGraph('stage3Div', s3);
          break;
        }
      }

    } else {
      ref = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '.txt');
      this.createGraph('chartDiv', ref);
    }
    this.loaded = true;
  }

  public closeTest(): void {
    this.testDetailClose.emit(true);
  }

  recalcTest() {

    let ref = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '.txt');

    if (this.selectedItem.calculationResult.testType === 'ecoli') {
      ref = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '-eColiStage' +
        this.selectedItem.calculationResult.eColiStage + '.txt');
    } else if (this.selectedItem.calculationResult.testType === 'c19') {
      ref = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '-c19Stage' +
        this.selectedItem.calculationResult.c19Stage + '.txt');
    }else if (this.selectedItem.calculationResult.testType === 'legionella') {
      ref = this.fireStorage.ref('testResultsData/' + this.selectedItem.calculationResult.testId + '-legionellaStage' +
        this.selectedItem.calculationResult.legionellaStage + '.txt');
    }


    ref.getDownloadURL().subscribe(url => {

      this.http.get(url).subscribe((data: any) => {

        const testData = {

          testId: this.selectedItem.calculationResult.testId,
          vialType: this.selectedItem.calculationResult.testType,
          dataPoints: data.dataPoints,
          initialVialState: data.initialVialState,
          uid: this.selectedItem.uid,
          device: {id: this.selectedItem.calculationResult.deviceMacAddress},
          eColiStage: this.selectedItem.calculationResult.eColiStage || '',
          c19Stage: this.selectedItem.calculationResult.c19Stage || '',
          legionellaStage: this.selectedItem.calculationResult.legionellaStage || '',
          recalc: true, // REQUIRED
          location: this.selectedItem.location,
          waterSource: this.selectedItem.waterSource
        };

        const downloadUrl = 'https://us-central1-ebi-prod.cloudfunctions.net/calculationService';

        this.httpClient
          .post(downloadUrl, testData)
          .subscribe((result: any) => {
            console.log('returned update ' + JSON.stringify(result));
            this.selectedItem.calculationResult = result.calculationResult;
          });


      });
    });

  }


  createGraph(divname, ref) {

    ref.getDownloadURL().subscribe(url => {

      this.http.get(url).subscribe((data: any) => {

        console.log('graphing data from  ' + url);

        const jsonData = this.ebi.deviceDatatoJSONString(data.dataPoints);
        this.zone.runOutsideAngular(() => {

          const chart = am4core.create(divname, am4charts.XYChart);
          am4core.useTheme(am4themes_animated);
          chart.paddingRight = 20;

          const timeAxis = chart.xAxes.push(new am4charts.ValueAxis());
          const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
          const redSeries = chart.series.push(new am4charts.LineSeries());
          const greenSeries = chart.series.push(new am4charts.LineSeries());
          const blueSeries = chart.series.push(new am4charts.LineSeries());

          redSeries.name = 'Red';
          redSeries.dataFields.valueX = 'seq';
          redSeries.dataFields.valueY = 'red';
          redSeries.stroke = am4core.color('red');
          redSeries.strokeWidth = 2;

          greenSeries.name = 'Green';
          greenSeries.dataFields.valueX = 'seq';
          greenSeries.dataFields.valueY = 'green';
          greenSeries.stroke = am4core.color('green');
          greenSeries.strokeWidth = 2;

          blueSeries.name = 'Blue';
          blueSeries.dataFields.valueX = 'seq';
          blueSeries.dataFields.valueY = 'blue';
          blueSeries.stroke = am4core.color('blue');
          blueSeries.strokeWidth = 2;
          console.log(chart, 'chart');
          /* Add legend */
          chart.legend = new am4charts.Legend();

          /* Create a cursor */
          chart.cursor = new am4charts.XYCursor();
          chart.data = JSON.parse(jsonData);


        });

      });
    });


  }

  ngOnDestroy() {
    this.zone.runOutsideAngular(() => {
      if (this.chart) {
        this.chart.dispose();
      }
    });
    console.log('unsubscribing');
    if (this.itemSubscription) {
      this.itemSubscription.unsubscribe();
    }
    console.log('unsubscribed');
  }


  createPdf() {
    this.ebi.createPdf(this.selectedItem);
  }

  downloadRawData() {
    this.ebi.downloadRawData(this.selectedItem);
  }

  async handleNoteChange($event: Event, testId: string) {
    await this.apiService.handleNoteChange($event, testId, this.apiUid, this.idToken);
  }

  async getUserSavedData(idToken: string, initialize?: boolean) {
    this.loaded = false;
    const userData = await this.apiService.getUserData(this.selectedItem.uid, idToken);
    this.testUserData = userData;
    const userCustomClaims = await this.apiService.getUserCustomClaims(this.idToken, this.apiUid);
    const userOrgId = userCustomClaims.orgData?.orgId || userData.data.orgId;
    this.userOrgData = await this.apiService.getOrgData(this.idToken, userOrgId);

    this.userSavedPlaces = userData.data.places ? userData.data.places : [];
    console.log('userSavedPlaces1111111', this.userSavedPlaces);
    this.userSavedWaterSources = userData.data.waterSources ? userData.data.waterSources : [];
    if ((this.userRole === 'admin' && this.userOrgData.sharingLocations) || this.userRole === 'superuser') {
      const userList = await this.apiService.getOrgUsers(this.idToken, userOrgId);
      const orgPlacesArray = [];
      const orgWaterSourcesArray = [];
      for (const orgUser of userList) {
        if (orgUser.userData?.uid !== this.apiUid) {
          const places = orgUser.userData?.places;
          const sources = orgUser.userData?.waterSources;
          if (places) {
            orgPlacesArray.push(places);
          }
          if (sources) {
            orgWaterSourcesArray.push(sources);
          }
        }
      }
      for (const orgPlaces of orgPlacesArray) {
        if (orgPlaces !== '') {
          this.userSavedPlaces = this.userSavedPlaces.concat(orgPlaces);
        }
      }
      for (const orgSources of orgWaterSourcesArray) {
        this.userSavedWaterSources = this.userSavedWaterSources.concat(orgSources);
      }
    }
    if (initialize) {
      // tslint:disable-next-line:max-line-length
      this.lastTypedValue = this.selectedItem.location?.formatted_address || this.selectedItem.location?.name || this.selectedItem.location || '';
      this.lastTypedSourceValue = this.selectedItem.location?.waterSource || this.selectedItem.waterSource || '';
    }

    // override place with user saved place (used for difference in custom geotag)
    const savedPlace = this.userSavedPlaces.find(place => place.place_id === this.selectedItem.location?.place_id);
    if (savedPlace) {
      this.selectedItem.location = {...this.selectedItem.location, ...savedPlace};
    }
    this.filterUserPlaces(this.lastTypedValue);
    this.filterUserWaterSources(this.lastTypedSourceValue);
    this.isEditingLocation = false;
    this.isEditingWaterSource = false;

    this.position = {lat: this.selectedItem.location.lat, lng: this.selectedItem.location.lng}; // set position to place

    this.loaded = true; // hide loading spinner
  }

  filterUserPlaces(value?) {
    const filterValue = value ? typeof value === 'string' ? value : '' : this.lastTypedValue ? this.lastTypedValue : '';
    this.filteredUserSavedPlaces = this.userSavedPlaces
      .filter(place => { // Filter by user input
        if (place.formatted_address && place.place_id) {
          return place.place_id !== 'no_location' && place.formatted_address.toLowerCase().includes(filterValue.toLowerCase()) ||
            place.place_id !== 'no_location' && place.name.toLowerCase().includes(filterValue.toLowerCase());
        }
        return place.place_id !== 'no_location' && place.name && place.name.toLowerCase().includes(filterValue.toLowerCase());
      })
      .sort( // Sort by most recent time created
        (a, b) => (a.time_created > b.time_created) ? -1 : ((b.time_created > a.time_created) ? 1 : 0)
      )
      .slice(0, 3); // Display max 3
    this.lastTypedValue = filterValue;

    // To prevent adding duplicate custom places
    this.isDuplicatePlace = this.userSavedPlaces.filter(place => {
      return place.name === this.lastTypedValue || place.formatted_address === this.lastTypedValue;
    }).length > 0;
  }

  filterUserWaterSources(value?) {
    const filterValue = value ? typeof value === 'string' ? value : '' : this.lastTypedSourceValue ? this.lastTypedSourceValue : '';
    console.log(filterValue, this.lastTypedSourceValue, 'values');
    this.lastTypedSourceValue = filterValue;
    this.filteredUserSavedWaterSources = this.userSavedWaterSources.filter(waterSource => {
      return waterSource.name && waterSource.name.toLowerCase().includes(filterValue.toLowerCase())
        && waterSource.place_id === this.selectedItem.location.place_id;
    }).slice(0, 5);
  }

  async navigateToUser() {
    await this.router.navigate(['/user/', this.testUserData.data.uid], {state: this.testUserData.data});

  }

  private async loadOrgUsers() {
    const data = await this.apiService.getOrgUsers(this.idToken, this.userOrgId);
    for (const user of data) {
      this.orgUsers.push(user.userRecord.uid);
    }
  }

  downloadStageData(stage: number) {
    let tempStage: number;
    if (this.selectedItem.calculationResult.legionellaStage) {
      tempStage = this.selectedItem.calculationResult.legionellaStage;
      this.selectedItem.calculationResult.legionellaStage = stage;
    }
    this.ebi.downloadRawData(this.selectedItem);
    this.selectedItem.calculationResult.legionellaStage = tempStage;
  }
}
